import { render, staticRenderFns } from "./ChatTwelveProblemsAst.vue?vue&type=template&id=44ce8b7d&scoped=true"
import script from "./ChatTwelveProblemsAst.vue?vue&type=script&lang=js"
export * from "./ChatTwelveProblemsAst.vue?vue&type=script&lang=js"
import style0 from "./ChatTwelveProblemsAst.vue?vue&type=style&index=0&id=44ce8b7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ce8b7d",
  null
  
)

export default component.exports